import { Grid2 } from '@mui/material';
import React, { useEffect } from 'react';

import { ResourceDetailItemContainer } from '@/shared/components/ui/resource-detail/content/resource-detail-content.styled';
import { TResourceDetailContent } from '@/shared/components/ui/resource-detail/content/resource-detail-content.types';
import { ResourceDetailItem } from '@/shared/components/ui/resource-detail/item/resource-detail-item';
import { COMPACT_ITEMS_PER_ROW } from '@/shared/components/ui/resource-detail/resource-detail.constants';
import {
  getCompactItems,
  getFittingCompactItems,
  getFullItems,
  getResourceDetailItemSize,
} from '@/shared/components/ui/resource-detail/resource-detail.utils';

export const ResourceDetailContent: React.FC<TResourceDetailContent> = ({
  items,
  compact: isCompact = false,
  itemsPerRow = 4,
  compactItemsPerRow = COMPACT_ITEMS_PER_ROW,
}) => {
  const visibleItems = isCompact
    ? getFittingCompactItems(items, compactItemsPerRow)
    : getFullItems(items);

  const droppedCompactItems = isCompact
    ? getCompactItems(items).length - visibleItems.length
    : 0;

  useEffect(() => {
    if (droppedCompactItems > 0) {
      console.warn(
        `ResourceDetailContent: compact view fits ${compactItemsPerRow} columns, so ${droppedCompactItems} item(s) were dropped. Use showOnlyOn: 'full' or smaller colSpans to trim the compact view.`,
      );
    }
  }, [compactItemsPerRow, droppedCompactItems]);

  const usedColumns = visibleItems.reduce(
    (total, item) => total + (item.colSpan ?? 1),
    0,
  );

  // Compact sizes the grid to the columns actually used so the row fills;
  // fall back to itemsPerRow so an empty compact list can't yield columns={0}.
  const containerColumns = isCompact ? usedColumns || itemsPerRow : itemsPerRow;

  return (
    <ResourceDetailItemContainer
      container
      spacing="1.5rem"
      columns={containerColumns}
    >
      {visibleItems.map((item, index) => (
        <Grid2
          key={`resource-detail-item-${index}`}
          size={getResourceDetailItemSize(containerColumns, item.colSpan)}
        >
          <ResourceDetailItem {...item} />
        </Grid2>
      ))}
    </ResourceDetailItemContainer>
  );
};
